module.exports = __webpack_public_path__ + "static/media/_MIC2616.thumbnail.d14b6a41.png";